const CHECK_ICON = 'M20 6 9 17l-5-5'

export const TESTIMONIAL_CARDS = [
  { name: 'Rahul A. · Mumbai', quote: 'The career prediction was astonishingly precise.' },
  { name: 'Priya M. · Delhi', quote: 'My marriage situation resolved within weeks.' },
  { name: 'Sanjay K. · Kolkata', quote: 'He described events I never told anyone.' },
  { name: 'Anita S. · Bangalore', quote: 'One session changed my understanding completely.' },
]

export const METHOD_CARDS = [
  {
    title: 'Birth Chart Analysis',
    desc: 'Full Lagna, Navamsa & divisional charts',
    circle: { cx: 12, cy: 12, r: 10 },
    paths: ['m9 12 2 2 4-4'],
  },
  {
    title: 'Dasha Prediction',
    desc: 'Vimshottari, Yogini & sub-period timing',
    circle: { cx: 12, cy: 12, r: 4 },
    paths: ['M12 2v20M2 12h20'],
  },
  {
    title: 'Gem Remedies',
    desc: 'Certified gemstones & energisation protocol',
    polygon: '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2',
  },
  {
    title: 'Planetary Yoga',
    desc: 'Mantra, yantra & ritual prescription',
    paths: ['M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z'],
    lines: [[4, 22, 4, 15]],
  },
]

export const COMMITMENT_CARDS = [
  {
    title: 'Full Discretion',
    desc: 'Absolute confidentiality on every reading',
    rect: { width: 18, height: 11, x: 3, y: 11, rx: 2, ry: 2 },
    paths: ['M7 11V7a5 5 0 0 1 10 0v4'],
  },
  {
    title: 'Uncompromised Accuracy',
    desc: 'Only verified classical methodology used',
    paths: ['M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', 'm9 12 2 2 4-4'],
  },
  {
    title: 'Genuine Care',
    desc: 'Personal attention, not assembly-line readings',
    paths: ['M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z'],
  },
  {
    title: 'Follow-up Support',
    desc: 'Post-consultation clarity whenever needed',
    paths: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  },
]

export const CENTER_ICONS = [
  { circle: { cx: 9, cy: 7, r: 4 }, paths: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M22 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'] },
  { circles: [{ cx: 12, cy: 12, r: 10 }, { cx: 12, cy: 12, r: 6 }, { cx: 12, cy: 12, r: 2 }] },
  { paths: ['M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0'], circle: { cx: 12, cy: 12, r: 3 } },
  { paths: ['m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z'], circle: { cx: 12, cy: 12, r: 10 } },
]

export { CHECK_ICON }
